export const articles = [
  {
    id: 'a001',
    title: '日本樱花前线2024完全解读：从南到北追樱全攻略',
    cover: 'https://readdy.ai/api/search-image?query=beautiful%20map%20of%20Japan%20showing%20cherry%20blossom%20front%20line%20from%20Okinawa%20to%20Hokkaido%2C%20soft%20pink%20gradient%20illustrating%20bloom%20dates%2C%20delicate%20sakura%20branch%20illustrations%20as%20decorative%20elements%2C%20editorial%20magazine%20design%2C%20warm%20cream%20and%20dusty%20pink%20color%20palette%2C%20elegant%20minimal%20composition&width=800&height=450&seq=sakura-article-001&orientation=landscape',
    category: '赏樱攻略',
    summary: '日本气象协会每年都会发布樱花开花预测，被称为"樱花前线"。了解樱花前线，是规划赏樱之旅的第一步。',
    author: '樱花小编',
    date: '2024-03-10',
    views: 56800,
    content: `## 什么是樱花前线？

每年春天，日本的樱花从南端的冲绳开始绽放，一路向北推进，直到五月中下旬抵达北海道。气象机构将各地樱花开花的时间点连成一条线，就是著名的"樱花前线"。

## 2024年樱花前线预测

根据日本气象协会发布的最新预测数据，2024年樱花开花时间总体比往年略早：

### 九州地区（3月下旬）
- **福冈**：预计开花日 3月22日，满开日 3月30日
- **熊本**：预计开花日 3月24日，满开日 4月1日
- **鹿儿岛**：预计开花日 3月25日，满开日 4月2日

### 关西地区（3月下旬-4月上旬）
- **大阪**：预计开花日 3月27日，满开日 4月4日
- **京都**：预计开花日 3月28日，满开日 4月5日
- **奈良**：预计开花日 3月29日，满开日 4月6日

### 关东地区（3月下旬-4月上旬）
- **东京**：预计开花日 3月24日，满开日 4月1日
- **横滨**：预计开花日 3月25日，满开日 4月2日

### 东北地区（4月中下旬）
- **仙台**：预计开花日 4月10日，满开日 4月17日
- **青森**：预计开花日 4月22日，满开日 4月29日

### 北海道（5月上旬-中旬）
- **函馆**：预计开花日 4月30日，满开日 5月6日
- **札幌**：预计开花日 5月2日，满开日 5月9日

## 追樱小贴士

从开花到满开大约需要一周时间，满开后最佳观赏期通常持续一周左右。如果遇到风雨天气，花期会大幅缩短。

建议关注日本气象协会官网获取最新预测更新，根据实际情况灵活调整行程。`,
  },
  {
    id: 'a002',
    title: '中国最美十大赏樱地，不出国门也能看绝美樱花',
    cover: 'https://readdy.ai/api/search-image?query=stunning%20aerial%20view%20of%20Chinese%20traditional%20garden%20with%20cherry%20blossoms%20surrounding%20a%20classical%20pavilion%20by%20a%20serene%20lake%2C%20pink%20blossoms%20reflecting%20on%20calm%20water%2C%20spring%20morning%20mist%2C%20Chinese%20landscape%20painting%20aesthetic%2C%20soft%20ethereal%20tones%2C%20harmonious%20composition&width=800&height=450&seq=sakura-article-002&orientation=landscape',
    category: '赏樱攻略',
    summary: '中国拥有众多世界级的赏樱胜地，从武汉大学到无锡鼋头渚，每一处都美得令人心醉。',
    author: '樱花小编',
    date: '2024-03-15',
    views: 72300,
    content: `## 中国赏樱文化

虽然樱花常与日本联系在一起，但中国实际上拥有悠久的赏樱传统。中国本土樱花品种丰富，从南到北都有令人惊艳的赏樱胜地。

## 十大赏樱名所

### 1. 武汉大学
每年的樱花季，武大就变成了粉色的海洋。长达数百米的樱花大道两侧种满了日本捐赠的樱花树，与百年老建筑交相辉映。

**最佳观赏期**：3月中下旬
**门票**：需提前预约

### 2. 无锡鼋头渚
太湖之滨的鼋头渚，素有"太湖第一名胜"之称。三万株樱花依山傍水，花开时节如云似雪。

**最佳观赏期**：3月下旬-4月上旬
**特色**：夜樱观赏、水上赏樱

### 3. 北京玉渊潭公园
北京市区内最大的赏樱地，拥有近20个品种、2000余株樱花。

**最佳观赏期**：3月下旬-4月中旬
**特色**：品种丰富，花期较长

### 4. 南京鸡鸣寺
鸡鸣寺路的樱花隧道是南京春天最美的风景线，古寺与樱花的组合意境悠远。

**最佳观赏期**：3月中下旬

### 5. 青岛中山公园
国内樱花种植历史最悠久的公园之一，拥有2万余平方米的樱花林。

**最佳观赏期**：4月中下旬
**特色**：单樱和双樱两个品种，花期长达一个月

### 6. 昆明圆通山
由于昆明气候温暖，这里的樱花在2月中下旬就会盛开，是全国最早开放的赏樱地之一。

**最佳观赏期**：2月下旬-3月上旬

### 7. 西安青龙寺
千年古刹配上千株樱花，古典与现代的交融令人沉醉。

**最佳观赏期**：3月下旬-4月上旬

### 8. 上海顾村公园
上海最大的樱花主题公园，拥有超过1.2万株樱花树。

**最佳观赏期**：3月中旬-4月中旬

### 9. 广州百万葵园
南方最早迎来樱花季的地方之一，品种以广州樱为主。

**最佳观赏期**：2月-3月

### 10. 大连旅顺樱花园
拥有全国面积最大的樱花林之一，晚樱品种丰富。

**最佳观赏期**：4月下旬-5月上旬

## 赏樱出行建议

提前规划非常重要！建议出行前关注当地樱花花期预报，尽量避开周末高峰。清晨和傍晚是拍摄樱花的黄金时间，光线柔和，人也相对较少。`,
  },
  {
    id: 'a003',
    title: '樱花品种图鉴：带你认识20种最美的樱花',
    cover: 'https://readdy.ai/api/search-image?query=botanical%20illustration%20style%20collection%20of%20different%20cherry%20blossom%20varieties%20arranged%20elegantly%2C%20showing%20single%20petal%20and%20double%20petal%20types%20in%20various%20shades%20of%20pink%20and%20white%2C%20scientific%20yet%20artistic%20composition%2C%20vintage%20herbarium%20aesthetic%2C%20cream%20paper%20texture%20background&width=800&height=450&seq=sakura-article-003&orientation=landscape',
    category: '赏樱攻略',
    summary: '你知道吗？世界上有超过600种樱花品种。从最常见的染井吉野到稀有的御衣黄，每一种都有独特的魅力。',
    author: '樱花小编',
    date: '2024-03-22',
    views: 45100,
    content: `## 樱花家族

樱花属于蔷薇科樱属，全世界约有600多个品种，其中日本拥有超过300种。不同品种的樱花在花色、花形、花期上各有特色。

## 常见品种介绍

### 染井吉野（Somei Yoshino）
日本最常见的樱花品种，约占日本樱花总数的80%。花朵为淡粉色，五瓣单层，先花后叶。

**特征**：花开时整棵树呈淡粉色，极其壮观
**花期**：3月下旬-4月上旬

### 八重樱（Yaezakura）
泛指花瓣超过五枚的重瓣樱花品种的统称。花朵大而饱满，形如牡丹。

**特征**：花瓣多层，颜色从粉红到深粉不等
**花期**：4月中下旬（比染井吉野晚约两周）

### 枝垂樱（Shidarezakura）
枝条如柳枝般下垂，花朵沿枝条绽放，形成粉色瀑布般的景象。

**特征**：垂枝形态，极具观赏性
**花期**：3月下旬-4月上旬

### 山樱（Yamazakura）
日本原生品种，多见于山地。花叶同放，新叶呈红褐色。

**特征**：野生种，树形高大可达20米
**花期**：3月下旬-4月上旬

### 河津樱（Kawazuzakura）
早樱品种，原产于静冈县河津町。花色较深，呈粉紫色。

**特征**：花期早，2月即可开花
**花期**：2月上旬-3月上旬

### 江户彼岸樱（Edo Higan）
日本寿命最长的樱花品种，树龄可达千年以上。花朵较小，淡粉色。

**特征**：树龄长，树形优美
**花期**：3月中下旬

### 御衣黄（Gyoiko）
极其稀有的绿色樱花品种，花瓣呈淡绿色，中间有红色条纹。

**特征**：花色独特，十分珍贵
**花期**：4月中下旬

## 如何辨认不同品种？

最简单的方法是通过花瓣数量、花色和开花时间来区分。单瓣五枚的是染井吉野系，超过五枚的是八重樱系，枝干垂下的就是枝垂樱了。`,
  },
  {
    id: 'a004',
    title: '延时摄影入门教程：如何拍出绝美樱花绽放视频',
    cover: 'https://readdy.ai/api/search-image?query=professional%20camera%20equipment%20setup%20for%20timelapse%20photography%2C%20DSLR%20camera%20on%20sturdy%20tripod%20pointing%20at%20a%20delicate%20cherry%20blossom%20branch%2C%20intervalometer%20attached%2C%20soft%20natural%20window%20light%2C%20clean%20minimalist%20workspace%20aesthetic%2C%20warm%20neutral%20tones&width=800&height=450&seq=sakura-article-004&orientation=landscape',
    category: '赏樱攻略',
    summary: '延时摄影能将数小时甚至数天的樱花绽放过程浓缩成几十秒的震撼画面。本文带你从零开始学习延时拍摄。',
    author: '樱花小编',
    date: '2024-03-18',
    views: 38700,
    content: `## 什么是延时摄影？

延时摄影（Time-lapse）是以远低于正常播放帧率的间隔拍摄一系列照片，然后以正常速度播放，从而将长时间的变化过程压缩成短时间视频的摄影技术。

## 拍摄樱花的准备工作

### 设备清单
1. **相机**：任何支持间隔拍摄的相机或手机
2. **三脚架**：稳定性是第一要素
3. **间隔定时器**：相机的内置功能或外接设备
4. **充足的存储卡和电池**
5. **ND滤镜**（可选）：用于白天长曝光

### 相机设置建议
- **模式**：手动模式（M档）
- **光圈**：f/8 - f/11（保证景深）
- **ISO**：尽可能低（100-400）
- **白平衡**：固定，不要自动
- **对焦**：手动对焦，锁定焦点

## 拍摄参数计算

拍摄樱花绽放通常需要4-8小时。假设我们要制作一个10秒的延时视频（25fps），总共需要250张照片。

- 拍摄时长：6小时 = 360分钟
- 所需照片数：250张
- 间隔时间：360 ÷ 250 ≈ 1分26秒/张

实际操作中，建议间隔设置在30秒到2分钟之间。

## 后期制作

1. **导入照片**：使用Lightroom进行批量调色
2. **合成视频**：使用Premiere Pro或DaVinci Resolve将照片序列合成为视频
3. **添加音乐**：选择合适的背景音乐

## 手机也能拍延时

现在大多数智能手机都内置了延时摄影功能。虽然效果不如专业相机，但胜在方便快捷，非常适合入门练习。`,
  },
  {
    id: 'a005',
    title: '京都小众赏樱秘境：避开人潮的五个绝美地点',
    cover: 'https://readdy.ai/api/search-image?query=hidden%20secluded%20Kyoto%20temple%20garden%20with%20a%20single%20ancient%20cherry%20blossom%20tree%20in%20full%20bloom%20beside%20a%20traditional%20wooden%20veranda%2C%20morning%20light%20with%20soft%20shadows%2C%20peaceful%20zen%20atmosphere%2C%20no%20people%2C%20fine%20art%20photography%20with%20muted%20sage%20and%20pink%20palette&width=800&height=450&seq=sakura-article-005&orientation=landscape',
    category: '日本樱花',
    summary: '厌倦了岚山和清水寺的人山人海？这五个京都鲜为人知的赏樱宝地，让你独享樱花树下的宁静时光。',
    author: '樱花小编',
    date: '2024-03-25',
    views: 52100,
    content: `## 避开人潮的京都赏樱

京都的樱花季美则美矣，但热门景点的人潮也确实令人望而却步。好在京都寺庙神社众多，藏着许多不为人知的赏樱秘境。

### 1. 原谷苑
**关键词**：私人庭园、垂枝樱

位于京都西北部的私人庭园，仅在樱花季对外开放。园内种植了大量枝垂樱，粉色的花枝如瀑布般倾泻而下。

地址：京都市北区大北山原谷乾町36
开放时间：3月下旬-4月下旬，9:00-17:00
门票：成人1500日元

### 2. 半木之道
**关键词**：鸭川畔、免费

鸭川西岸长约800米的散步道，种植了约70株枝垂樱。人少景美，最适合清晨散步赏花。

地址：京都市北区上賀茂半木町
交通：地铁乌丸线北山站步行5分钟

### 3. 平野神社
**关键词**：品种丰富、夜樱

拥有约60个品种、400株樱花的神社。由于品种多样，花期从3月中旬一直持续到4月下旬。

地址：京都市北区平野宮本町1
特色：夜樱点灯（3月下旬-4月中旬）

### 4. 上品莲台寺
**关键词**：一棵巨大的樱花树

寺内一棵树龄超过200年的巨大枝垂樱，冠幅达到惊人的28米。一棵树就足以让你震撼。

### 5. 雨宝院
**关键词**：密集花海

小小一座寺院，却密集种植了多种樱花。盛花期的密度令人惊叹，抬头只见花不见天。

## 出行建议

这些地点公共交通都相对方便，建议购买京都巴士一日券（700日元）。清晨7点前到达，基本可以独享美景。`,
  },
  {
    id: 'a006',
    title: '樱花与日本文化：从花见传统到现代审美',
    cover: 'https://readdy.ai/api/search-image?query=traditional%20Japanese%20hanami%20scene%20with%20people%20in%20kimono%20sitting%20under%20cherry%20blossom%20trees%20on%20tatami%20mats%2C%20elegant%20bento%20boxes%20and%20sake%20set%2C%20paper%20lanterns%2C%20warm%20evening%20light%2C%20cultural%20heritage%20photography%2C%20rich%20yet%20soft%20atmospheric%20tones&width=800&height=450&seq=sakura-article-006&orientation=landscape',
    category: '日本樱花',
    summary: '樱花在日本文化中占有特殊地位。"花见"不仅是一项春季活动，更承载着深厚的文化内涵和哲学思考。',
    author: '樱花小编',
    date: '2024-04-01',
    views: 41300,
    content: `## 花见的起源

花见（Hanami）传统可以追溯到奈良时代（710-794年）。最初人们观赏的是梅花，到了平安时代（794-1185年），樱花逐渐取代梅花成为花见的主角。

## 樱花的象征意义

### 物哀之美
日本人从樱花的短暂绽放中感受到"物哀"（Mono no aware）——对美好事物转瞬即逝的淡淡哀愁。樱花从盛开到凋零仅有一周左右，这种短暂反而成就了它的极致之美。

### 新生与希望
樱花盛开恰逢日本学校开学和公司新年度开始的四月，因此也象征着新的开始和希望。

### 武士精神的隐喻
"花是樱花，人是武士"——这句日本谚语将樱花与武士道精神联系在一起。樱花在最灿烂时凋落，正如武士在巅峰时坦然面对死亡。

## 现代花见文化

现代日本的花见仍然是一项全民参与的春季活动：

1. **公司花见**：许多公司会组织员工在公园占位置，下班后一起赏花饮酒
2. **家庭花见**：周末全家带上便当，在樱花树下享受天伦之乐
3. **夜樱观赏**：各地公园和寺庙会在樱花季点亮灯笼，营造梦幻的夜樱氛围

## 花见礼仪

- 不要折断樱花树枝
- 不要爬到树上
- 垃圾必须带走
- 占位置的蓝布要在离开时收走
- 适度饮酒，不要大声喧哗

樱花虽然美丽，但更需要每个人的爱护才能让更多人欣赏。`,
  },
];